import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Modal/Modal';
import {labels} from '../../../../util/utils';

const EditAccountSwitchWithoutSaveModal = ({
	show,
	onClose,
	setShowSureModal,
	selectAccountChange,
	nextAccount,
	setCreateNewAccount
}) => {
	return (
		<Modal
			show={show}
			title={labels.modalSwitchTitle}
			closeTitle={labels.modalCancelTitle}
			modalsize={'x-small'}
			modalContainerClass="deleteaccount-modal"
			showButtons
			confirmBtnTitle={labels.modalConfirmSwitch}
			closeBtnTitle={labels.modalCancelTitle}
			onOkClick={() => {
				setCreateNewAccount(false);
				selectAccountChange(nextAccount);
				setShowSureModal(false);
			}}
			onHide={onClose}
			modalonmodal
		>
			{labels.modalConfirmSwitchDescription}
		</Modal>
	);
};

EditAccountSwitchWithoutSaveModal.propTypes = {
	show: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired
};

export default EditAccountSwitchWithoutSaveModal;
